import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sanAngeloConfig } from "./data";

export default function SanAngeloPage() {
  return <CityPageTemplate config={sanAngeloConfig} />;
}